<template>
  <div v-if="showBanner" class="cookie-banner">
    <p>
      Наш веб-сајт користи тзв. колачиће (cookies) како би побољшао своју
      функционалност, као и квалитет информисања и услуга које пружа
      посетиоцима. Уколико наставите да прегледате наш веб-сајт сагласни сте с
      правилима наведеним у
      <a href="https://pravno-informacioni-sistem.rs/static/termsOfService"
        >условима коришћења</a
      >.
    </p>
    <button @click="acceptCookies">ПРИХВАТИ</button>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      showBanner: false,
    };
  },
  methods: {
    acceptCookies() {
      Cookies.set("cookiePolicyAccepted", "true", { expires: 30 });
      this.showBanner = false;
    },
  },
  mounted() {
    this.showBanner = !Cookies.get("cookiePolicyAccepted");
  },
};
</script>

<style>
.cookie-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f3f8fc;
  border: 1px solid #cfe3f4;

  padding: 10px;
  text-align: center;
  z-index: 1010;
}

.cookie-banner p {
  margin: 0;
  font-size: 14px;
}

.cookie-banner a {
  color: #1f2b38;
  text-decoration: underline;
}

.cookie-banner button {
  margin-left: 10px;
  margin-top: 10px;
  padding: 8px 15px;
  background-color: #1f2b38;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}
</style>
